import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import ImageFadeIn from "react-image-fade-in";
import { ref, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase";

function Card({
  title,
  subtitle,
  location,
  room,
  style,
  width,
  height,
  imageRef,
}) {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (imageRef) {
      const storageRef = ref(storage, imageRef);
      getDownloadURL(storageRef)
        .then((url) => {
          setImageUrl(url);
        })
        .catch((error) => {
          console.error("Error fetching image URL:", error);
        });
    }
  }, [imageRef]);

  return (
    <div className="card" style={style}>
      <div className="card-text">
        <div className="card-title">{title}</div>
        <div className="card-subtitle">{subtitle}</div>
        <div className="card-detail">{`${location} ${
          room ? `-${room}` : ""
        }`}</div>
      </div>
      {imageUrl ? (
        <ImageFadeIn
          src={imageUrl}
          height={height}
          width={width}
        />
      ) : (
        <div>
          <Skeleton height={height} width={width} />
        </div>
      )}
    </div>
  );
}

Card.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  imageRef: PropTypes.string,
  location: PropTypes.string,
  room: PropTypes.string,
};

export default Card;
